import React from 'react'
import './Home.scss'
import Navbar from '../Shared/Navbar/Navbar'
const Home = () => {
  return (
    <div>
     <Navbar />
    </div>
  )
}

export default Home
